import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { TypeFormats } from '../../../../shared/types/exportItem';

type ColumnContent = {
  [key: string]: string | number | boolean | any;
}

type Body = {
  format: TypeFormats,
  [key: string]: string | string[] | number | ColumnContent | ColumnContent[] | Record<string, string>[] | boolean | string;
};

@Injectable({
  providedIn: 'root'
})
export class ExportFileService {

  constructor(private cvApiService: CVApiService) {}

  async exportReport(url: string, body: Body) {
    try {
      const response = await this.cvApiService.post<string>(url, body);
      if (response.status_code == 200) {
        return response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error downloading file " + error.Message); // showErrorMessage is a global function
    }
    return '';
  };

    async exportReportString(url: string, body: string) {
      try {
        const response = await this.cvApiService.post<string>(url, body);
        if (response.status_code == 200) {
          return response.data;
        } else {
          throw response;
        }
      } catch (error) {
        showErrorMessage("Error downloading file " + error.Message); // showErrorMessage is a global function
      }
      return '';
    };
  
    async exportHistoryReport(url: string, body: Body) {
      try {
        const response = await this.cvApiService.post<string>(url, body);
        if (response.status_code == 200) {
          return response;
        } else {
          throw response;
        }
      } catch (error) {
        showErrorMessage("Error downloading file " + error.Message); // showErrorMessage is a global function
      }
      return '';
    };
  
}
